import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './MenuHamburguerArrow.scss';

const useStyles = makeStyles(theme => ({
  menuButton: {
    backgroundColor: 'inherit',
    outline: 'none'
  }
}));

export default ({ isChecked, handleClick, color ,spaceMargin_0_2}) => {
  const classes = useStyles();
  return (
    <button
      className={`${classes.menuButton} ${color} ${spaceMargin_0_2} hamburger hamburger--arrow btn ${
        isChecked ? true : 'is-active'
      }`}
      type="button"
      onClick={handleClick}
    >
      <span className="hamburger-box">
        <span className={`${color} hamburger-inner`} ></span>
      </span>
    </button>
  );
};